import { render, staticRenderFns } from "./UnidataEditorBasicMultiple.vue?vue&type=template&id=05e36be0&"
import script from "./UnidataEditorBasicMultiple.vue?vue&type=script&lang=js&"
export * from "./UnidataEditorBasicMultiple.vue?vue&type=script&lang=js&"
import style0 from "./UnidataEditorBasicMultiple.vue?vue&type=style&index=0&id=05e36be0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports